import styled from 'styled-components'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const ShowInactiveContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  min-width: 250px;
`

export const ShowInactiveLabel = styled.span`
  font-variant-numeric: lining-nums proportional-nums;
  color: ${colorsOptions.greys['grey-40']};

  /* 600 (semibold)/600-R */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  line-height: 18.2px; /* 130% */
  letter-spacing: 0.2px;

  &[data-checked='true'] {
    color: ${colorsOptions.greys['grey-100']};
  }

  &[data-disabled='true'] {
    color: ${colorsOptions.greys['grey-40']};
  }
`
